import { useLocation, Link } from "react-router-dom";
import { cn } from "@/lib/utils";

export default function SiteNav() {
  const location = useLocation();
  const isPredict = location.pathname === "/" || location.pathname === "/veikkaa";
  const isVote = location.pathname === "/vote";
  const isArchive = location.pathname === "/tapahtumat";

  const linkClass = (active) => cn(
    "px-5 sm:px-7 py-2.5 text-xs sm:text-sm lg:text-base font-bold uppercase tracking-wider transition-all border",
    active
      ? "bg-[#FF3B30] text-white border-[#FF3B30]"
      : "text-white/80 border-white/40 hover:text-white hover:border-white/60"
  );

  return (
    <div className="flex items-center justify-center gap-1 mt-6" data-testid="site-nav">
      <Link to="/veikkaa" className={linkClass(isPredict)} data-testid="nav-predictions">Veikkaukset</Link>
      <Link to="/vote" className={linkClass(isVote)} data-testid="nav-vote">Äänestä</Link>
      <Link to="/tapahtumat" className={linkClass(isArchive)} data-testid="nav-archive">Menneet</Link>
    </div>
  );
}
